import React from 'react';
import { CHATGPT_SUBSCRIPTION_BLOCKED_MESSAGE } from '../../utils/particularChatGPTAccess';
import './SubscriptionBlockedModal.css';

const SubscriptionBlockedModal = ({
  open,
  onClose,
  message = CHATGPT_SUBSCRIPTION_BLOCKED_MESSAGE
}) => {
  if (!open) return null;

  return (
    <div className="subscription-blocked-overlay" onMouseDown={onClose}>
      <section
        className="subscription-blocked-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="subscription-blocked-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="subscription-blocked-icon">
          <i className="fas fa-lock" />
        </div>
        <div className="subscription-blocked-content">
          <h3 id="subscription-blocked-title">Funcionalidad no incluida</h3>
          <p>{message}</p>
        </div>
        <div className="subscription-blocked-actions">
          <button type="button" className="subscription-blocked-button" onClick={onClose}>
            Entendido
          </button>
        </div>
      </section>
    </div>
  );
};

export default SubscriptionBlockedModal;
